var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "Subheader",
        {
          attrs: { title: "Cofactors", search: "cofactors" },
          model: {
            value: _vm.search,
            callback: function ($$v) {
              _vm.search = $$v
            },
            expression: "search",
          },
        },
        [
          _c(
            "v-tooltip",
            {
              attrs: { bottom: "" },
              scopedSlots: _vm._u([
                {
                  key: "activator",
                  fn: function ({ on }) {
                    return [
                      _c(
                        "span",
                        _vm._g({}, on),
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "success",
                                disabled: !_vm.canAddCofactors,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.addCofactor()
                                },
                              },
                            },
                            [
                              _c("v-icon", { staticClass: "mr-1" }, [
                                _vm._v("add"),
                              ]),
                              _vm._v(
                                _vm._s(
                                  _vm.$t("Button.AddCoFactorAnalyteLink")
                                ) + "\n          "
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            },
            [
              _vm._v(" "),
              _c("span", [_vm._v("All cofactors have been added.")]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "mb-3" },
        [
          _c(
            "v-card-text",
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.headers,
                  items: _vm.cofactorAnalyteList,
                  search: _vm.search,
                  "hide-actions": "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _c(
                          "tr",
                          {
                            class: props.item.IsMismatched
                              ? "warning lighten-2"
                              : "",
                            attrs: {
                              title: props.item.IsMismatched
                                ? _vm.$t(
                                    "GuidelineCoFactor.CoFactorAnalyteMismatchedUnitGroupMsg",
                                    {
                                      analyte:
                                        props.item.Mismatched.AnalyteName,
                                      analyteUnitGroup:
                                        props.item.Mismatched.AnalyteUnitGroup,
                                      cofactor: props.item.Mismatched.Name,
                                      cofactorUnitGroup:
                                        props.item.Mismatched.CofactorUnitGroup,
                                    }
                                  )
                                : null,
                            },
                          },
                          [
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.CoFactorName)),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.AnalyteName)),
                            ]),
                            _vm._v(" "),
                            _c("td", { staticClass: "text-xs-left" }, [
                              _vm._v(_vm._s(props.item.Description)),
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "text-xs-center" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      dark: "",
                                      color: "warning",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickEdit(props.item)
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { staticClass: "mr-1" }, [
                                      _vm._v("edit"),
                                    ]),
                                    _vm._v(
                                      _vm._s(_vm.$t("Button.Edit")) +
                                        "\n            "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      small: "",
                                      dark: "",
                                      color: "delete",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.clickDelete(props.item)
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { staticClass: "mr-1" }, [
                                      _vm._v("delete_forever"),
                                    ]),
                                    _vm._v(
                                      _vm._s(_vm.$t("Button.Delete")) +
                                        "\n            "
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("Subheader", { attrs: { title: "Cofactor Calculation Strategy" } }),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("v-layout", { attrs: { wrap: "", "align-center": "" } }, [
                _c(
                  "div",
                  {
                    staticClass: "font-weight-bold",
                    staticStyle: { flex: "0 0 125px" },
                  },
                  [_vm._v("Current Strategy:")]
                ),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.currentAlgorithmName))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-xs-right" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { small: "" },
                        on: {
                          click: function ($event) {
                            _vm.formModal = true
                          },
                        },
                      },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-1", attrs: { color: "warning" } },
                          [_vm._v("edit")]
                        ),
                        _vm._v(_vm._s(_vm.$t("Button.Edit")) + "\n          "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("v-layout", [
                _c(
                  "div",
                  {
                    staticClass: "font-weight-bold",
                    staticStyle: { flex: "0 0 125px" },
                  },
                  [_vm._v("Description:")]
                ),
                _vm._v(" "),
                _c("div", [_vm._v(_vm._s(_vm.selectedAlgorithmDescription))]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          !_vm.algorithmIsModified && !_vm.noDefaultValue
            ? _c(
                "v-flex",
                { attrs: { xs12: "", "pb-4": "" } },
                [
                  _vm.isLoading
                    ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
                    : _c(
                        "v-window",
                        {
                          model: {
                            value: _vm.configWindowKey,
                            callback: function ($$v) {
                              _vm.configWindowKey = $$v
                            },
                            expression: "configWindowKey",
                          },
                        },
                        _vm._l(_vm.algorithms, function (algo) {
                          return _c(
                            "v-window-item",
                            { key: algo.Key, attrs: { value: algo.Key } },
                            [
                              _c(algo.ConfigComponent, {
                                tag: "component",
                                attrs: { mapSameAnalyte: _vm.mapSameAnalyte },
                                on: { notify: _vm.handleNotification },
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("AppModal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.$t("GuidelineCoFactor.addTitle")))]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-layout",
                  { attrs: { wrap: "" } },
                  [
                    _c(
                      "v-form",
                      {
                        model: {
                          value: _vm.forms.addCofactorFormValid,
                          callback: function ($$v) {
                            _vm.$set(_vm.forms, "addCofactorFormValid", $$v)
                          },
                          expression: "forms.addCofactorFormValid",
                        },
                      },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                rules: [_vm.rules.required],
                                label: "CoFactor",
                                items: _vm.addCoFactorList,
                                "item-text": "Name",
                                "item-value": "Id",
                              },
                              model: {
                                value: _vm.cofactorData.cofactorId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cofactorData, "cofactorId", $$v)
                                },
                                expression: "cofactorData.cofactorId",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "", "pl-3": "", "pr-3": "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                label: "Link Analyte",
                                items: _vm.analyteListMatchCofactorUnit,
                                "item-text": "AnalyteName",
                                "item-value": "Id",
                              },
                              model: {
                                value: _vm.cofactorData.AnalyteId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.cofactorData, "AnalyteId", $$v)
                                },
                                expression: "cofactorData.AnalyteId",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-alert",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isCofactorAnalyteMapValid,
                                expression: "!isCofactorAnalyteMapValid",
                              },
                            ],
                            attrs: { type: "warning", outline: "" },
                          },
                          [_c("div", [_vm._v(_vm._s(_vm.confirmMessage))])]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      color: "success",
                      disabled: !_vm.forms.addCofactorFormValid,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.saveCofactor()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        return _vm.closeDialog()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.addDialog,
          callback: function ($$v) {
            _vm.addDialog = $$v
          },
          expression: "addDialog",
        },
      }),
      _vm._v(" "),
      _c("AppModal", {
        attrs: { persistent: "", "max-width": "800" },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v(_vm._s(_vm.$t("GuidelineCoFactor.editTitle")))]
            },
            proxy: true,
          },
          {
            key: "text",
            fn: function () {
              return [
                _c(
                  "v-form",
                  {
                    model: {
                      value: _vm.forms.editCofactorFormValid,
                      callback: function ($$v) {
                        _vm.$set(_vm.forms, "editCofactorFormValid", $$v)
                      },
                      expression: "forms.editCofactorFormValid",
                    },
                  },
                  [
                    _c("v-autocomplete", {
                      attrs: {
                        label: "CoFactor",
                        hint:
                          "Cofactor is used in unit group(s):" +
                          _vm.getHint(_vm.cofactorData.cofactorId),
                        "persistent-hint": "",
                        items: _vm.cofactorList,
                        "item-text": "Name",
                        "item-value": "Id",
                        disabled: "",
                      },
                      model: {
                        value: _vm.cofactorData.cofactorId,
                        callback: function ($$v) {
                          _vm.$set(_vm.cofactorData, "cofactorId", $$v)
                        },
                        expression: "cofactorData.cofactorId",
                      },
                    }),
                    _vm._v(" "),
                    _c("v-autocomplete", {
                      attrs: {
                        label: "Link Analyte",
                        items: _vm.analyteListMatchCofactorUnit,
                        "item-text": "AnalyteName",
                        "item-value": "Id",
                      },
                      model: {
                        value: _vm.cofactorData.AnalyteId,
                        callback: function ($$v) {
                          _vm.$set(_vm.cofactorData, "AnalyteId", $$v)
                        },
                        expression: "cofactorData.AnalyteId",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "v-alert",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.isCofactorAnalyteMapValid,
                            expression: "!isCofactorAnalyteMapValid",
                          },
                        ],
                        attrs: { type: "warning", outline: "" },
                      },
                      [_c("div", [_vm._v(_vm._s(_vm.confirmMessage))])]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "actions",
            fn: function () {
              return [
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      disabled: !_vm.forms.editCofactorFormValid,
                      color: "success",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.clickEditSave()
                      },
                    },
                  },
                  [
                    _c("v-icon", [_vm._v("done")]),
                    _vm._v(_vm._s(_vm.$t("Button.Save")) + "\n      "),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "secondary", outline: "" },
                    on: {
                      click: function ($event) {
                        return _vm.closeDialog()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.editDialog,
          callback: function ($$v) {
            _vm.editDialog = $$v
          },
          expression: "editDialog",
        },
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.deleteDialog,
            callback: function ($$v) {
              _vm.deleteDialog = $$v
            },
            expression: "deleteDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                {
                  staticStyle: { padding: "0px" },
                  attrs: { dense: "", color: "primary", dark: "" },
                },
                [
                  _c("v-toolbar-title", [
                    _vm._v(_vm._s(_vm.$t("GuidelineCoFactor.deleteTitle"))),
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: {
                        click: function ($event) {
                          _vm.deleteDialog = false
                        },
                      },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-card-text", [
                _vm._v(_vm._s(_vm.$t("GuidelineCoFactor.deleteMsg"))),
              ]),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "error" },
                      on: {
                        click: function ($event) {
                          return _vm.agreeDelete()
                        },
                      },
                    },
                    [
                      _c("v-icon", [_vm._v("delete_forever")]),
                      _vm._v(_vm._s(_vm.$t("Button.Delete")) + "\n        "),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "secondary", outline: "" },
                      on: {
                        click: function ($event) {
                          _vm.deleteDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("FormModal", {
        attrs: {
          "original-value": _vm.currentAlgorithm,
          dialog: _vm.formModal,
        },
        on: {
          change: _vm.updateFormModal,
          save: _vm.clickSaveAlgorithmStrategy,
          cancel: _vm.resetFormValues,
          notify: _vm.handleNotification,
        },
        model: {
          value: _vm.selectedAlgorithm,
          callback: function ($$v) {
            _vm.selectedAlgorithm = $$v
          },
          expression: "selectedAlgorithm",
        },
      }),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          staticStyle: { "text-align": "center" },
          attrs: { color: _vm.snackColor, timeout: null, top: "" },
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.snackMessage) + "\n    "),
          _c(
            "v-btn",
            {
              attrs: { dark: "", flat: "" },
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  $event.preventDefault()
                  _vm.snackbar = false
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("Button.Close")))]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("ErrorDialog", {
        attrs: { data: _vm.errorDialog.data, title: _vm.errorDialog.title },
        model: {
          value: _vm.errorDialog.show,
          callback: function ($$v) {
            _vm.$set(_vm.errorDialog, "show", $$v)
          },
          expression: "errorDialog.show",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }